import { StateCreator } from "zustand";
import { ButtonProps } from "@mui/material";

export interface ActionDialogProps {
    actions: (ButtonProps & { tooltipTitle?: string })[];
    header: string | JSX.Element;
    content: string | JSX.Element;
    open: boolean;
    onAction?: (action: ButtonProps) => Promise<void>;
}

export interface ActionDialogSlice {
    actionDialog: ActionDialogProps;
    setActionDialog: (state: ActionDialogProps) => void;
    updateActionDialog: (partialState: Partial<ActionDialogProps>) => void;
    resetActionDialog: () => void;
}

const initialActionDialogState: ActionDialogProps = {
    open: false,
    actions: [],
    content: "",
    header: "",
};

export const createActionDialogSlice: StateCreator<ActionDialogSlice, [], [], ActionDialogSlice> = (set) => ({
    actionDialog: initialActionDialogState,

    setActionDialog: (state) => set({ actionDialog: state }),
    updateActionDialog: (partialState) => set((state) => ({ actionDialog: { ...state.actionDialog, ...partialState } })),
    resetActionDialog: () => set({ actionDialog: initialActionDialogState }),
});

